<footer class="app-footer">
  <span><a href="https://www.openpolis.it">OPDM</a> &copy; 2018-2025 openpolis.</span>
</footer>
